export const LF = 0x0a;
export const ESC = 0x1b;
export const GS = 0x1d;
